import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/shared/components/ui/Card';

export const EmptyEmployeeState = () => {
  const { t } = useTranslation('oneOnOne');
  return (
    <Card className="flex-1 bg-white rounded-xl shadow-md border border-gray-200">
      <CardContent className="flex h-full items-center justify-center py-12">
        <div className="text-center">
          <p className="text-lg text-muted-foreground">
            {t('selectEmployeeToView')}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
